export const environment = {
  accountService: 'https://stg-cms.avery.com/account',
  appDomain: 'https://stg-cms.avery.com',
  navDomain: 'https://stg-cms.avery.com/avylib/dist/assets',
  authKey: 'wwjH7clZ8E5v5BsgCqQ5zHYf9OlZ8dCB',
  consumerPrivacyUrl: 'https://stg-cms.avery.com/ccpa',
  demandBase:
    'https://api.demandbase.com/api/v2/ip.json?key=bd38bd2672863d51e8e5dda8ca51dba2b99f302a',
  environment: 'stage',
  production: true,
  image: 'https://img.avery.com',
  domain: 'https://stg-cms.avery.com',
  magento: 'https://stg-cart.avery.com',
  dpo: 'https://stg-services.print.avery.com/dpp/public',
  dpoDownloadables:
    'https://stg-services.print.avery.com/dpp/public/v3/content/downloadables',
  dpoV3: 'v3',
  dpoV4: 'v4',
  dpoV5: 'v5',
  deploymentId: 'US_en',
  ssoService: 'https://stg-cms.avery.com/authenticate',
};
export const config = {
  authKey: 'wwjH7clZ8E5v5BsgCqQ5zHYf9OlZ8dCB',
  env: 'prd',
  recaptchaKey: '6Ld76NsUAAAAAG0c0SDAT3M11Qgp5siUA39_Mr1e',
  recaptchaSecret: '6Ld76NsUAAAAALFx963ytrUOC1ssOXn6OgqmnCrj',
  theme: {
    cookieKey: 'avythmmde',
    modes: {
      default: {
        landingPage: environment.domain,
        toggleLabel: 'Avery',
      },
      industrial: {
        landingPage: `${environment.domain}/industrial`,
        toggleLabel: 'Avery Industrial',
        URLregex: /^\/industrial/,
      },
    },
  },
  version: '1.0.0',
};
